import axios from "axios";
import { API_URL } from "../appConstants";
import { axiosInstance } from "./axiosInstance";

export async function fetchStates() {
    try {
        const response = await axiosInstance.post(API_URL + 'states'); // Replace with your API endpoint
        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}
export async function fetchJobRoles() {
    try {
        const response = await axiosInstance.post(API_URL + 'jobRoles');

        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}
export async function fetchPreferredWorkArea() {
    try {
        const response = await axiosInstance.post(API_URL + 'preferredWorkArea');

        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}
export async function fetchPreferredWorkType() {
    try {
        const response = await axiosInstance.post(API_URL + 'preferredWorkType');

        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}
export async function fetchJobRoleSpecialities(jobRoleID, type) {
    try {
        console.log("jobRoleID,type", jobRoleID, type);

        const response = await axiosInstance.post(API_URL + 'jobRoleSpecialities', { JOBROLE_ID: jobRoleID, TYPE: type });
        if (response?.data?.STATUS) {
            return response.data.OUTPUT;

        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}
export const ValidateUserEmail = async (values, callBack) => {

    await axiosInstance.post(API_URL + "validateUserEmail", values)
        .then((res) => {
            callBack(res.data);
            // setTimeout(() => {

            // }, 3000);
        }).catch(async error => {
            console.log("validateUserEmail: ", error.message);
        })
}





//Rakshwinder
export async function fetchClinicianEssentailsDocuments() {
    try {
        console.log("API_URL + 'jobRoles", API_URL + 'jobRoles')
        const response = await axiosInstance.get(API_URL + 'fetchClinicianEssentailsDocuments'); // Replace with your API endpoint

        if (response?.data?.STATUS) {
            return response.data.OUTPUT;
        } else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching states:', error.message);
        return [];
    }
}